export default [
  {
    // 社会
    cid: 2,
    label: 'สังคม'
  },
  {
    // 娱乐
    cid: 3,
    label: 'บันเทิง'
  },
  {
    // 国际
    cid: 4,
    label: 'ต่างประเทศ'
  },
  {
    // 运动
    cid: 5,
    label: 'กีฬา'
  },
  {
    // 经济
    cid: 6,
    label: 'เศรษฐกิจ'
  },
  {
    // 科技
    cid: 7,
    label: 'เทคโนโลยี'
  },
  {
    // 时尚
    cid: 8,
    label: 'แฟชั่น'
  },
  {
    // 旅游
    cid: 10,
    label: 'ท่องเที่ยว'
  },
  {
    // 游戏
    cid: 11,
    label: 'เกม'
  },
  {
    // 健康
    cid: 12,
    label: 'สุขภาพ'
  },
  {
    // 美食
    cid: 13,
    label: 'อาหาร'
  },
  {
    // 汽车
    cid: 14,
    label: 'ยานยนต์'
  }
  ,
  {
    // 情感
    cid: 18,
    label: 'อารมณ์'
  }
  ,
  {
    // 生活
    cid: 19,
    label: 'ไลฟ์สไตล์'
  },
  {
    // 教育
    cid: 21,
    label: 'การศึกษา'
  }     
]



// WEBPACK FOOTER //
// ./src/assets/cids.js